(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("EventCarousel", [
            'jquery',
            'jqueryTD',
            'owlCarousel',
            'w5modules'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require('jqueryTD'),
            require('owlCarousel'),
            require('w5modules')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.jquery,
            root.jqueryTD,
            root.owlCarousel,
            root.w5modules
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, jqueryTD, owlCarousel, w5modules) {

    // Define debounce function in jQuery
    $.debounce = jqueryTD.Cowboy.debounce;

    var screenWidth = screen.width,
        options = {
            mouseDrag: !window.w5modules.isMobile(),
            animateOut: 'fadeOutLeft',
            animateIn: 'fadeInRight',
            responsive: {
                0: {
                    items: 1,
                    margin: 30,
                    autoWidth: true
                },
                768: {
                    items: 1,
                    slideBy: 1,
                    margin: 30,
                    autoWidth: true
                },
                1024: {
                    items: 1,
                    margin: 30,
                    autoWidth: false
                },
                1200: {
                    items: 1,
                    autoWidth: false
                },
                1400: {
                    items: 1,
                    margin: 30,
                    autoWidth: false
                }
            },
            onInitialized: function () {
                this.$element.addClass('owl-carousel');
                this.$element.addClass('animated');
            }
        },
        debug = false,
        config = {
            responsive: "",
            eventsContainerSelector: "",
            eventItemSelector: "",
            row: 2,
            width: ""
        };

    function error (err) {
        console.log(err);
    }

    function _getViewPort () {
      let items;

      if (!Object.entries) {
            Object.entries = function( obj ){
              var ownProps = Object.keys( obj ),
                  i = ownProps.length,
                  resArray = new Array(i); // preallocate the Array
              while (i--)
                resArray[i] = [ownProps[i], obj[ownProps[i]]];

              return resArray;
            };

            items = Object.entries(config.responsive);
        } else {
          items = Object.entries(config.responsive);
        }

        let firstItem = items[0],
            lastItem = items[items.length - 1],
            viewPort;

        if ( screenWidth >= lastItem[0] ) {
            viewPort = lastItem[0];
        } else {
            for ( let index in items ) {
                index = parseInt(index);

                if ( screenWidth >= items[index][0] && screenWidth < items[index + 1][0] ) {
                    viewPort = items[index][0];
                }
            }
        }

        return viewPort;
    }

    function _set (key, value) {
        if ( !config.hasOwnProperty(key) ) {
            throw "Ez a beállítás (" + key + ") nem engedélyezett!";
        } else {
            config[key] = value;
        }
    }

    function _setConfig (key, value) {
        if ( value ) {
            _set(key, value);
        } else {
            if ( config.responsive[_getViewPort()].hasOwnProperty(key) ) {
                let value = config.responsive[_getViewPort()][key];

                _set(key, value);
            } else {
                _set('width', 'auto');
            }
        }
    }

    function _callConfig (key) {
        if ( typeof config[key] === "function") {
            return config[key]();
        } else {
            return config[key];
        }
    }

    function configuration (options) {
        screenWidth = screen.width;

        if (options) {
            _setConfig('responsive', options.viewports);
            _setConfig('eventsContainerSelector', options.containerSelector);
            _setConfig('eventItemSelector', options.itemSelector);
        }

        _setConfig('row');
        _setConfig('width');
    }

    function initCarousel () {
        $(config.eventsContainerSelector).owlCarousel(options);

        if (debug) {
            console.log("InitCarousel");
        }
    }

    function destroy () {
        $(config.eventsContainerSelector).trigger('destroy.owl.carousel');
        $(config.eventsContainerSelector).removeClass('owl-carousel');

        if (debug) {
            console.log("DestroyCarousel");
        }
    }

    function resetDom (callback) {
        let $items = $(config.eventsContainerSelector).find(config.eventItemSelector),
            container = document.createDocumentFragment();

        $items.each(function (index, item) {
            item.style.width = _callConfig('width');
            container.appendChild(item);
        });

        $(config.eventsContainerSelector).html(container);

        if (debug) {
            console.log("ResetDOM");
        }

        if ( typeof callback === "function") {
            callback();
        }
    }

    function editDom () {
        let items = document.querySelectorAll(config.eventItemSelector),
            array = document.createDocumentFragment(),
            count = 0,
            process = (window.innerWidth >= 1024) ? true : false,
            rowDiff = config.row;

        if ( _callConfig('width') && items.length > 0) {
          items[0].style.width = _callConfig('width');
        }

        if (items.length > 0) {
          while (process) {
              if ( (items[0].clientHeight * rowDiff) >= (document.querySelector(config.eventsContainerSelector).clientHeight - 50) ) {
                  rowDiff--;
              } else {
                  process = false;
              }
          }
        }

        _setConfig('row', rowDiff);

        for ( let i = 0; i <= items.length - 1; i = i + config.row ) {
            let div = document.createElement("div");
            div.style.width = _callConfig('width');

            for ( var j = 0; j <= config.row - 1; j++ ) {

                if (items[count]) {
                    items[count].style.width = _callConfig('width');
                    div.appendChild(items[count]);
                }

                count++;
            }

            array.appendChild(div);
        }

        document.querySelector(config.eventsContainerSelector).appendChild(array);

        if (debug) {
            console.log("EditDOM");
        }

        initCarousel();
    }

    return function (options) {
        try {
            if ( $(options.containerSelector).length !== 0 ) {
                $(window).on('resize', $.debounce(500, function () {
                    configuration();

                    $.when(destroy()).done(function () {
                        resetDom(editDom);
                    });
                }));

                $(function() {
                    configuration(options);
                    editDom();
                });
            }
        } catch (err) {
            error(err);
        }
    };

}));



//////////////////
// WEBPACK FOOTER
// ./js/modules/eventCarousel/index.js
// module id = 19
// module chunks = 0